module.exports = __webpack_public_path__ + "img/logo-vfix.900af973.svg";